module.exports = __webpack_public_path__ + "img/round.715c381c.gif";